/* VendorDetailsSection.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import Button from '@atlaskit/button/new';
import { media } from '@atlaskit/primitives/responsive';
import { TextInput } from '@atlassian/mpac-ui';
import { useRef } from 'react';
import { createImagePreview, validateDescription, validateImageFile } from '../ManageVendorCreate.utils';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const _18 = "._5ral1dfr{object-fit:cover}";
const _17 = "._4t3i1wto{height:3rem}";
const _16 = "._2rkolb4i{border-radius:var(--ds-radius-xsmall,2px)}";
const _15 = "._19itpp12{border:var(--_18x9sjc)}";
const _14 = "._18s8192h{margin:var(--_170nn8b)}";
const _13 = "._syaz9lu1{color:var(--ds-text-accent-red,#ae2e24)}";
const _12 = "._18s81b66{margin:var(--ds-space-050,4px)}";
const _11 = "._11c81vhk{font:var(--ds-font-heading-xxsmall,normal 600 9pt/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _10 = "._otyr1b66{margin-bottom:var(--ds-space-050,4px)}";
const _9 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _8 = "._1e0c1ule{display:block}";
const _7 = "._11c8140y{font:var(--ds-font-heading-xsmall,normal 600 14px/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _6 = "._18s8hw0i{margin:var(--_33h2xm)}";
const _5 = "@media (min-width:48rem){._14b5jvo9{width:40rem}}";
const _4 = "@media (min-width:48rem){._14b5tye8{width:20rem}}";
const _3 = "._1bsb1osq{width:100%}";
const _2 = "@media (min-width:48rem){._1r3v1epz{padding-left:var(--ds-space-1000,5pc)}}";
const _ = "._19bvidpf{padding-left:0}";
const LeftPadding = null;
const FieldWidth20 = null;
const FieldWidth40 = null;
const FileUploadContainer = null;
const LogoLabel = null;
const LogoErrorMessage = null;
const LogoPreviewContainer = null;
const LogoPreviewImage = null;
export const VendorDetailsSection = _ref => {
  let {
    logoPreview,
    setLogoPreview,
    logoError,
    setLogoError,
    submissionErrors
  } = _ref;
  const fileRef = useRef(null);
  const onLogoChange = async event => {
    var _event$target$files;
    const file = (_event$target$files = event.target.files) === null || _event$target$files === void 0 ? void 0 : _event$target$files[0];
    const validationError = validateImageFile((file === null || file === void 0 ? void 0 : file.name) || '');
    if (validationError) {
      setLogoError(validationError);
      setLogoPreview(null);
      return;
    }
    setLogoError(null);
    if (file) {
      const preview = await createImagePreview(file);
      setLogoPreview(preview);
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_19bvidpf _1r3v1epz"]),
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_3, _4]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _14b5tye8"]),
            children: /*#__PURE__*/_jsx(TextInput, {
              name: "vendorName",
              label: "Name",
              width: "100%",
              helperMessage: "Enter your vendor name. If you're not associated with a company or organization, use your own name.",
              isRequired: true,
              testId: "vendor-name-input",
              applyDefaultValidation: true,
              submissionError: submissionErrors === null || submissionErrors === void 0 ? void 0 : submissionErrors.vendorName
            })
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_3, _5]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _14b5jvo9"]),
            children: /*#__PURE__*/_jsx(TextInput, {
              name: "description",
              label: "Description",
              width: "100%",
              helperMessage: "Describe your organization in 750 characters or less. This description is displayed on your vendor page in the Marketplace.",
              fieldType: "textarea",
              validate: validateDescription,
              testId: "vendor-description-input",
              applyDefaultValidation: true,
              submissionError: submissionErrors === null || submissionErrors === void 0 ? void 0 : submissionErrors.description
            })
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_6, _, _2]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_18s8hw0i _19bvidpf _1r3v1epz"]),
        style: {
          "--_33h2xm": ix("var(--ds-space-100, 8px)".concat(" 0px ", "var(--ds-space-250, 20px)"))
        },
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_7, _8, _9, _10]
          }), /*#__PURE__*/_jsx("label", {
            htmlFor: "logo",
            className: ax(["_11c8140y _1e0c1ule _syaz1gjq _otyr1b66"]),
            children: "Logo"
          })]
        }), logoError && /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_11, _12, _13]
          }), /*#__PURE__*/_jsx("div", {
            role: "alert",
            "aria-live": "assertive",
            className: ax(["_11c81vhk _18s81b66 _syaz9lu1"]),
            children: logoError
          })]
        }), logoPreview && /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_14]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_18s8192h"]),
            style: {
              "--_170nn8b": ix("var(--ds-space-050, 4px)".concat(" 0"))
            },
            children: /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_15, _16, _17, _18]
              }), /*#__PURE__*/_jsx("img", {
                src: logoPreview,
                alt: "Logo preview",
                className: ax(["_19itpp12 _2rkolb4i _4t3i1wto _5ral1dfr"]),
                style: {
                  "--_18x9sjc": ix("1px solid ".concat("var(--ds-border, #091E4224)"))
                }
              })]
            })
          })]
        }), /*#__PURE__*/_jsx(Button, {
          appearance: "default",
          onClick: () => {
            var _fileRef$current;
            return (_fileRef$current = fileRef.current) === null || _fileRef$current === void 0 ? void 0 : _fileRef$current.click();
          },
          "aria-controls": "logo",
          children: "Select File"
        }), /*#__PURE__*/_jsx("input", {
          id: "logo",
          hidden: true,
          type: "file",
          accept: "image/*",
          onChange: onLogoChange,
          "aria-label": "upload vendor logo image",
          ref: fileRef
        })]
      })]
    })]
  });
};